function mapNode(node) {
  node.id = node.code;
  if (node.classification === 'linkedin') {
    node.tmpLabel = node.label;
    node.label = node.title;
  }
  if (node.children && node.children.length) {
    node.children.map(mapNode);
  } else {
    node.children = undefined;
  }
  return node;
}

export function industryAPI(classification, search) {
  return Vue.http.get('industries/', {
    params: { classification, search }
  });
}

export function getIndustry(industry) {
  return new Promise(async (resolve, reject) => {
    try {
      const { body } = await industryAPI(industry);
      resolve(body.map(mapNode));
    } catch (e) {
      reject(new Error(`Error trying to get Industry name: ${industry}`));
    }
  });
}

export function resetStates(industryRef) {
  // Reset states.
  industryRef.localSearch.noResults = true;
  industryRef.traverseAllNodesDFS(node => {
    if (node.isBranch) {
      node.isExpandedOnSearch = false;
      node.showAllChildrenOnSearch = false;
      node.isMatched = false;
      node.hasMatchedDescendants = false;
      industryRef.$set(industryRef.localSearch.countMap, node.id, {
        ALL_CHILDREN: 0,
        ALL_DESCENDANTS: 0,
        LEAF_CHILDREN: 0,
        LEAF_DESCENDANTS: 0
      });
    }
  });
  return true;
}

export function matchChildren(currentNodes, updateInstructions, results = 0) {
  updateInstructions.forEach(instruction => {
    const match = currentNodes.find(node => {
      return node.id === instruction.code;
    });
    if (match) {
      match.isMatched = true;
      results++;
      if (instruction.children.length) {
        match.isExpandedOnSearch = true;
        matchChildren(match.children, instruction.children, results);
      }
    }
  });
  return results;
}
